export default {"src":"/_next/static/media/gezonde-kantine.dc89917f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};